import React from 'react';
import { Form, InputNumber, Select } from 'antd';

const { Option } = Select;
const DiscountValue = () => {
  return (
    <Form.Item shouldUpdate noStyle>
      <Form.Item
        name='discountValue'
        label='Promotion'
        rules={[
          {
            required: true,
            message: 'Please enter promotion value',
          },
        ]}
      >
        <InputNumber
          addonAfter={
            <Form.Item name='discountType' noStyle initialValue={'MONEY'}>
              <Select style={{ width: 100 }}>
                <Option value={'MONEY'}>Dollar</Option>
                <Option value={'PERCENT'}>Percent</Option>
              </Select>
            </Form.Item>
          }
          placeholder='0'
          min={0}
          max={100000000}
          size='large'
        />
      </Form.Item>
    </Form.Item>
  );
};

export default DiscountValue;
